/* ============================================================
   Zalso — color-scheme controller
   Light is the fixed default; dark is an explicit, persisted override
   (no OS-following). Never flash the wrong theme.

   HOW IT WORKS
   - tokens/colors.css: :root = light (default), [data-theme="dark"] = dark.
   - This file only handles the OVERRIDE + PERSISTENCE layer.

   NO-FLASH (FART) GUARD
   Paste this tiny snippet in <head> BEFORE any stylesheet. It resolves the
   scheme — persisted override first, else the OS preference — and applies it
   before first paint:

     <script>
       try {
         var t = localStorage.getItem('zalso-theme');
         if (t !== 'light' && t !== 'dark') t = 'light';
         document.documentElement.setAttribute('data-theme', t);
       } catch (e) {}
     </script>

   Then load this file (defer is fine) for the toggle API.
   ============================================================ */
(function (global) {
  var KEY = "zalso-theme";
  var root = document.documentElement;

  function systemPrefersDark() {
    return global.matchMedia && global.matchMedia("(prefers-color-scheme: dark)").matches;
  }

  /** The scheme actually showing right now: "light" | "dark". */
  function resolved() {
    var attr = root.getAttribute("data-theme");
    if (attr === "light" || attr === "dark") return attr;
    return "light";
  }

  /** Persisted override, or null when following the system. */
  function preference() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  }

  /** Force a scheme and persist it. setScheme("light"|"dark"). */
  function setScheme(scheme) {
    if (scheme !== "light" && scheme !== "dark") return;
    root.setAttribute("data-theme", scheme);
    try { localStorage.setItem(KEY, scheme); } catch (e) {}
    emit();
  }

  /** Drop the override and follow the OS again. */
  function clearScheme() {
    root.removeAttribute("data-theme");
    try { localStorage.removeItem(KEY); } catch (e) {}
    emit();
  }

  /** Flip between light and dark (from whatever is currently showing). */
  function toggle() {
    setScheme(resolved() === "dark" ? "light" : "dark");
  }

  function emit() {
    try {
      global.dispatchEvent(new CustomEvent("zalso:themechange", { detail: { scheme: resolved() } }));
    } catch (e) {}
  }

  // Light is the fixed default. Dark is an explicit, persisted choice only —
  // no OS-following, so the theme never flips on its own (deterministic for demo + brand).

  global.ZalsoTheme = {
    resolved: resolved,
    preference: preference,
    setScheme: setScheme,
    clearScheme: clearScheme,
    toggle: toggle,
  };
})(window);
